import { createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { CustomHandler } from "@tLinc/Store/CustomHandlerCreator/CustomHandlerCreator";

export interface DiscontinuedProductToast {
    isShowToast: boolean;
    toastMessage: string;
}
type HandlerType = CustomHandler<{ discontinuedProductToast: DiscontinuedProductToast }>;

const DispatchSetShowDiscontinuedProductToast: HandlerType = props => {
    props.dispatch({
        type: "Data/DiscontinuedProductToast/DiscontinuedProductShowToast",
        discontinuedProductToast: props.parameter.discontinuedProductToast,
    });
};

export const chain = [DispatchSetShowDiscontinuedProductToast];

const setShowDiscontinuedProductToast = createHandlerChainRunner(chain, "SetShowDiscontinuedProductToast");
export default setShowDiscontinuedProductToast;
